import facepaint from 'facepaint';

const breakpoints = [736, 768, 1200, 1440];
const updateBreakpoints = [500, 800, 1100, 1450];

export const tablet = 768;
export const desktop = 1200;
export const largeDesktop = 1440;
export const mq = facepaint(breakpoints.map((bp) => `@media (min-width: ${bp}px)`));
export const newMq = facepaint(updateBreakpoints.map((bp) => `@media (min-width: ${bp}px)`));

export class MqWithBP {
  public renderMQ: (params: any) => {};
  constructor(bps: number[]) {
    this.renderMQ = facepaint(bps.map((bp) => `@media (min-width: ${bp}px)`));
  }
}
